import React from "react";
import { ArrowRightIcon, CircleCheckIcon, StarIcon } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { business } from "../data/business";
import { ui } from "../data/ui";
export function Hero() {
  const {
    t
  } = useLanguage();
  const checks = [ui.hero.reliable, ui.hero.trained, ui.hero.quality];
  return <section id="home" aria-labelledby="hero-title" className="relative isolate overflow-hidden bg-ink" data-id="element-229" data-mp="4jm53lei8xpi">
      <img src={business.heroImage} alt={t(ui.hero.imageAlt)} loading="eager" decoding="async" className="absolute inset-0 -z-20 h-full w-full object-cover object-[62%_center]" data-id="element-230" data-mp="127ec173d7daa" />
      <div className="absolute inset-0 -z-10 bg-black/60" aria-hidden="true" data-id="element-231" data-mp="ncgk2fc4optq" />
      <div className="absolute inset-y-0 left-0 w-1 bg-gold" aria-hidden="true" data-id="element-232" data-mp="neklmqmk1cqu" />

      <div className="mx-auto flex min-h-[calc(100svh-80px)] max-w-7xl flex-col justify-center px-5 py-20 sm:px-8 md:min-h-[calc(100svh-116px)] lg:py-24" data-id="element-233" data-mp="3d2tm12xxw8bd">
        <div className="max-w-4xl" data-id="element-234" data-mp="3j897lcz58bpj">
          <h1 id="hero-title" data-id="element-235" data-mp="3j9ah3d0igq55">
            <span className="block text-xs font-semibold uppercase tracking-[0.18em] text-gold sm:text-sm" data-id="element-236" data-mp="3o7lprkf2kuls">
              {t(ui.hero.seo)}
            </span>
            <span className="mt-6 block font-display text-[2.75rem] font-extrabold uppercase leading-[0.98] text-white sm:text-6xl lg:text-7xl" data-id="element-237" data-mp="399tc6xt32ga8">
              {t(ui.hero.line1)}
              <br data-id="element-238" data-mp="30gzu6sm952so" />
              <span className="text-gold" data-id="element-239" data-mp="30ggg5mzq2yjx">{t(ui.hero.line2)}</span>
            </span>
          </h1>
          <span className="mt-8 block h-px w-24 bg-gold" aria-hidden="true" data-id="element-240" data-mp="35aasu6gwud9i" />
          <p className="mt-8 max-w-xl text-lg leading-relaxed text-white/85" data-id="element-241" data-mp="2qkwiow5ifrt2">
            <span className="font-display text-xl italic text-gold" data-id="element-242" data-mp="2vievwyqk8t6v">{t(ui.hero.subGold)}</span> {t(ui.hero.subRest)}
          </p>
          <div className="mt-10 flex flex-col gap-3 sm:flex-row" data-id="element-243" data-mp="2hkghjtc8owrd">
            <a href="#contact" className="btn-gold h-14 px-8 text-base" data-id="element-244" data-mp="2lla4okhuy7j7">
              {t(ui.common.getEstimate)}
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-245" data-mp="s335tfryasyl" />
            </a>
            <a href="#services" className="btn-outline h-14 px-8 text-base" data-id="element-246" data-mp="nat7bbcrskkp">
              {t(ui.hero.secondary)}
            </a>
          </div>
        </div>

        <ul className="mt-14 grid max-w-4xl grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-247" data-mp="ia5kl1vkqpwa">
          <li className="col-span-2 lg:col-span-1" data-id="element-248" data-mp="deq40266mfw6">
            <a href={business.googleReviewsUrl} target="_blank" rel="noreferrer" className="flex h-full items-center gap-3 rounded-sm border border-gold/40 bg-black/55 px-4 py-3 backdrop-blur-sm transition-[border-color] duration-150 ease-out hover:border-gold" data-id="element-249" data-mp="1b1fgx72facwt">
              <span className="font-display text-2xl font-bold text-gold" data-id="element-250" data-mp="x0cs4mk1moi7">{business.rating}</span>
              <span className="flex flex-col" data-id="element-251" data-mp="3ltqc7blwotsz">
                <span className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-252" data-mp="3hrd9yx6dbe0y">
                  {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-253" data-mp="1xacf521xbhsp" data-mpi={i} />)}
                </span>
                <span className="mt-1 text-xs text-white/80" data-id="element-254" data-mp="218jw9y0aul4f">
                  {business.reviewCount}+ {t(ui.hero.reviews)}
                </span>
              </span>
            </a>
          </li>
          {checks.map(label => <li key={label.en} className="flex items-center gap-2.5 rounded-sm border border-white/15 bg-black/55 px-4 py-3 backdrop-blur-sm" data-id="element-255" data-mp="2g0c3fmpxwsv2">
              <CircleCheckIcon className="h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-256" data-mp="2kx2ge16g78c9" />
              <span className="text-sm font-medium text-white" data-id="element-257" data-mp="2p10dy7g4kb37">{t(label)}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}